// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-youtube-inline[data-v-3b4e6dc2] .y-video__inner{padding-bottom:0 !important}\n", ""]);
// Exports
module.exports = exports;
